// extracted by css-extract-rspack-plugin
export default {"list":"list-c28Dw5","loading":"loading-qqdNPI"};